<article class="hd-conditioning-card" [style.background]="info().cardColor">
  <!-- HEAD: impact-rang (links) + naam & keynote (rechts) -->
  <div class="hd-conditioning-card__head">
    <div class="hd-conditioning-card__rank">
      <span class="hd-conditioning-card__rank-number">{{ rank() }}</span>
      <span class="hd-conditioning-card__rank-label">{{ impactRankLabel() }}</span>
    </div>
    <div class="hd-conditioning-card__title">
      <h3 class="hd-conditioning-card__name">
        @if (info().colorGroupOrder !== null) {
          <sup class="hd-conditioning-card__order">{{ info().colorGroupOrder }}</sup>
        }
        {{ centerLabel() }}
      </h3>
      <p class="hd-conditioning-card__keynote">{{ keynote() }}</p>
    </div>
  </div>

  <!-- STATS: % ongedefinieerd · poorten · focus-badge -->
  <div class="hd-conditioning-card__stats">
    <div class="hd-conditioning-card__stat">
      <span class="hd-conditioning-card__stat-number">{{ info().undefinedPopulationLabel }}</span>
      <span class="hd-conditioning-card__stat-label">{{ undefinedLabel() }}</span>
    </div>
    <div class="hd-conditioning-card__stat">
      <span class="hd-conditioning-card__stat-number">{{ gateCount() }}</span>
      <span class="hd-conditioning-card__stat-label">{{ gatesLabel() }}</span>
    </div>
    <div class="hd-conditioning-card__focus">
      <div class="hd-conditioning-card__focus-badge">
        @for (glyph of focusConfig().glyphs; track $index) {
          <span class="hd-conditioning-card__focus-glyph">{{ glyph }}</span>
        }
        <span class="hd-conditioning-card__focus-short">{{ focusConfig().short }}</span>
      </div>
      <span class="hd-conditioning-card__focus-keynote">{{ focusKeynote() }}</span>
    </div>
  </div>

  <!-- OPEN-vraag -->
  <p class="hd-conditioning-card__open">
    <span class="hd-conditioning-card__inline-label">{{ openLabel() }}:</span> {{ openQuestion() }}
  </p>

  <!-- FYSIEK: lichaamsdelen (onderstreept, zoals op het poster) + potentiële fysieke
       uitdagingen (gedempt). De &ngsp; houdt de spatie na het label vast — Angular
       stript whitespace-only tekstnodes tussen elementen anders weg. -->
  <div class="hd-conditioning-card__physical">
    <p class="hd-conditioning-card__body-parts">
      <span class="hd-conditioning-card__inline-label">{{ physicalLabel() }}:</span>&ngsp;
      @for (seg of bodyPartSegments(); track $index) {@if (seg.bold) {<u>{{ seg.text }}</u>}@else {<span>{{ seg.text }}</span>}}
    </p>
    <p class="hd-conditioning-card__challenges">{{ challenges() }}</p>
  </div>
</article>
